import React from "react";
import html from "../../skills/html.png";
import css from "../../skills/css.png";
import js from "../../skills/js.png";
import node from "../../skills/node.png";
import express from "../../skills/express.png";
import react from "../../skills/react.png";
import c from "../../skills/c.png";
import github from "../../skills/github.png";
import Skills from "../Skills/Skills";
import './Experience.css';

const Experience = () => {
  return (
    <div className="mySkills" id="Skills">
    <h1>My Skills</h1>
    <span>Learning</span>

    <div
            className="blur"
            style={{ background: "rgb(238 210 255)", left: "0rem" }}
          ></div>
          <div
            className="blur"
            style={{
              background: "#C1F5FF",
              top: "-12rem",
              left: "-3rem",
              height: "11rem",
            }}
          ></div>

    <div className="exp">

    <div className="experience">
    <div className="a">
    <Skills image={html} name={'HTML'} type={"Intermediate"} />
    </div>
      
      <div className="b">
      <Skills image={css} name={'CSS'} type={"Intermediate"} />
      </div>

      <div className="c">
      <Skills image={js} name={'JS'} type={"Intermediate"} />
      </div>
      
      <div className="d">
      <Skills image={node} name={'NODE.JS'} type={"Intermediate"} />      
      </div>
      
    </div>

    <div className="experience">
    <div className="e">
    <Skills image={express} name={'EXPRESS'} type={"Intermediate"} />
    </div>
      
      <div className="f">
      <Skills image={react} name={'REACT'} type={"Intermediate"} />
      </div>
      
      <div className="g">
      <Skills image={c} name={'C++'} type={"Beginner"} />
      </div>
      
      <div className="h">
      <Skills image={github} name={'GITHUB'} type={"Beginner"} />
      </div>
      
    </div>

    

    </div>

    



    </div>    
  );
};

export default Experience;
